/** @format */

import React, { useState } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import InputFormRest from '../../../components/Form/InputFormRest';
import { useDispatch } from 'react-redux';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import PieChart from '@material-ui/icons/PieChart';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import { history } from '../../../core/history';
import { fractionsConstants } from '../../../modules/fractions/actions';
import { makeStyles } from '@material-ui/core';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import CustomSmallTextButton from '../../../components/Buttons/CustomSmallTextButton';
import { configDefault } from '../../../core/config';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

const initEntity = {
    mainname: '',
};

const initEntityStatus = {
    mainname: null,
};

const FractionAdd = (props: { classes: any }): React.ReactElement => {
    const dispatch = useDispatch();
    const [entity, setEntity] = useState<{ mainname: string }>(initEntity);
    const [entityStatus, setEntityStatus] = useState<{ mainname: string | null }>(initEntityStatus);

    const changeInput = (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number): void => {
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const handleSubmit = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/fractions', configDefault.PLATFORM_API_PREFIX)),
            fractionsConstants.ADD,
            entity,
            {
                onSuccess: (data: any) => {
                    NotificationHelper.notifySuccess('fractions:notify.added_success', dispatch);
                },
                onError: () => {
                    NotificationHelper.notifyError('fractions:notify.added_error', dispatch);
                },
            },
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    };

    const returnFractionList = (): void => {
        history.push(FormGeneralHelper.getRouteUrl('/fraction-list'));
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <Card>
                    <CardHeader icon={<PieChart />} trans="fractions:f.fraction" />
                    <CardBody>
                        <GridContainer spacing={2}>
                            <GridItem xs={12} md={12} lg={12}>
                                <InputFormRest
                                    classes={props.classes}
                                    callback={changeInput}
                                    stateName="mainname"
                                    stateObjectState={entityStatus.mainname}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="fractions:f.fraction_name"
                                    required={false}
                                    vMax={255}
                                    vMin={0}
                                    value={entity.mainname}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_POST) && (
                                    <CustomSmallTextButton label={'general:common.save'} callback={handleSubmit} callbackParam={{}} />
                                )}
                                <CustomSmallTextButton label={'general:common.cancel'} callback={returnFractionList} callbackParam={{}} />
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(FractionAdd);
